// extracted by mini-css-extract-plugin
export var quote = "style-module--quote--80ade";
export var quoteNumbers = "style-module--quote--numbers--1533c";
export var quoteSecondary = "style-module--quote--secondary--b5ed7";
export var quoteSuccess = "style-module--quote--success--a7dd2";
export var quote__author = "style-module--quote__author--e1c27";
export var quote__author__image = "style-module--quote__author__image--71424";
export var quote__bgPattern = "style-module--quote__bgPattern--e1fb8";
export var quote__content = "style-module--quote__content--e6865";
export var quote__data = "style-module--quote__data--f715b";
export var quote__icon = "style-module--quote__icon--1faa5";
export var quote__wrapper = "style-module--quote__wrapper--c39bb";